module.exports = __webpack_public_path__ + "img/1931111-41-9.b22a8271.png";